import { render } from "./cast-ballot-button.vue?vue&type=template&id=6428c2b5"
import script from "./cast-ballot-button.vue?vue&type=script&lang=js"
export * from "./cast-ballot-button.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__